import styled from 'styled-components';
import Colours from '/shared/styled/Colours';

export default styled.div`
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  background-color: ${Colours.whiteDark1};
  z-index: 1000;
  padding: 1rem;

  @media (width >= 501px) {
    padding: 3rem 4rem;
  }

  > * {
    display: flex;
    flex-direction: column;
    max-width: 62.666666rem;
    margin: 0 auto;

    @media (width >= 501px) {
      flex-direction: row;
    }

    > *:first-child {
      display: flex;
      flex-direction: column;
      flex: 1 1 50%;
      padding: 1rem 1rem 1rem 0;
      text-align: left;
    }

    > *:last-child {
      display: flex;
      flex-direction: column;
      justify-content: end;
      flex: 1 1 0%;
      padding: 1rem 0 1rem 1rem;
      text-align: center;

      > *:first-child {
        margin-bottom: 1.7rem;
      }

      @media (width >= 501px) {
        flex: 0 0 23%;
      }
    }
  }

  p {
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.3;

    @media (width >= 701px) {
      font-size: 0.9rem;
    }
  }

  button {
    margin: 0 auto;
    max-width: 500px;
  }
`;
